<template>
    <div>
        <Chart :constructorType="'chart'" class="hc" :options="chartOptions" ref="chartRef"></Chart>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import {Chart} from 'highcharts-vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTGRAPHS from '@/constants/graphs';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getTimeZone } from '@/functions/project';

const props = defineProps({
    color       : { required:true },
    title       : { required:true },
    arrayIPs    : { required:true },
    thridArray  : { required:true },
    firstArray  : { required:true },
    secondArray : { required:true },
    fourthArray : { required:true },
    name        : { type:String, required:true },
})
const yAxisTitle    = ref(CONSTGRAPHS.YAXISLABEL[props.name] || '');

/* eslint-disable */
const chartOptions:any = ref({
    chart: {
        type: 'column',
        options3d: {
            enabled: true,
            alpha: 15,
            beta: 15,
            viewDistance: 25,
            depth: 40
        }
    },
    title: {
        text: props.title
    },
    credits: {
        enabled: false
        },
    yAxis: {
        title: { text: yAxisTitle  }
    },
    xAxis: {
        categories: props.arrayIPs,
        title: { text: null },
        gridLineWidth: 1,
        lineWidth: 0
    },
    series: [
        {
            name: 'Normal',
            data: props.firstArray,
        },
        {
            name: 'Alerta',
            data: props.thridArray,
        },
        {
            name: 'Alarma',
            data: props.secondArray,
        },
        {
            name: 'Down',
            data: props.fourthArray,
        },
    ],
    plotOptions: {
        column: {
            stacking: 'normal',
            depth: 40
        }
    },
    exporting: { enabled: false },
    time: {
        timezone: getTimeZone()
    }
})


const chartRef = ref<any>();
const duplicateChart = ref();

onMounted(async () => {
    setTimeout(() => {
        duplicateChart.value = chartRef.value;
    }, 500);
});

onUnmounted(() => {
    if(duplicateChart.value){
        duplicateChart.value.chart.destroy();
    }
});
</script>
<style>


/***********************
******** NORMAL ********
***********************/ 
.highcharts-point.highcharts-color-0{
    stroke: #4FFF87 !important;
}
.highcharts-color-0 .highcharts-point{
    fill: #4FFF87 !important;
}
.highcharts-point.highcharts-color-0 .highcharts-3d-front{
    fill: #4FFF87 !important;
}
.highcharts-label.highcharts-tooltip.highcharts-color-0 tspan:nth-child(3){
    fill: #4FFF87 !important;
}
.highcharts-point.highcharts-color-0 .highcharts-3d-top{
    fill: #9CFFBB !important;
}
.highcharts-point.highcharts-color-0 .highcharts-3d-side{
    fill: #28BF58 !important;
}
/***********************
******** ALERT *********
***********************/ 
.highcharts-point.highcharts-color-2{
    stroke: #FF334B;
}
.highcharts-point.highcharts-color-2 .highcharts-3d-front{
    fill: #FF334B !important;
}
.highcharts-color-2 .highcharts-point{
    fill: #FF334B !important;
}
.highcharts-label.highcharts-tooltip.highcharts-color-2 tspan:nth-child(3){
    fill: #FF334B !important;
}
.highcharts-point.highcharts-color-2 .highcharts-3d-top{
    fill: #FF5266 !important;
}
.highcharts-point.highcharts-color-2 .highcharts-3d-side{
    fill: #B5071C !important;
}

/***********************
******** ALARM *********
***********************/
.highcharts-point.highcharts-color-1{
    stroke: #FFFC63;
}
.highcharts-point.highcharts-color-1 .highcharts-3d-front{
    fill: #FFFC63 !important;
}
.highcharts-color-1 .highcharts-point{
    fill: #FFFC63 !important;
}
.highcharts-label.highcharts-tooltip.highcharts-color-1 tspan:nth-child(3){
    fill: #FFFC63 !important;
}
.highcharts-point.highcharts-color-1 .highcharts-3d-top{
    fill: #FFFECC !important;
}
.highcharts-point.highcharts-color-1 .highcharts-3d-side{
    fill: #E3DF00 !important;
}

/***********************
******** DOWN *********
***********************/
.highcharts-point.highcharts-color-3{
    stroke: #828282;
}
.highcharts-point.highcharts-color-3 .highcharts-3d-front{
    fill: #828282 !important;
}
.highcharts-color-3 .highcharts-point{
    fill: #828282 !important;
}
.highcharts-label.highcharts-tooltip.highcharts-color-3 tspan:nth-child(3){
    fill: #828282 !important;
}
.highcharts-point.highcharts-color-3 .highcharts-3d-top{
    fill: #B5B5B5 !important;
}
.highcharts-point.highcharts-color-3 .highcharts-3d-side{
    fill: #303030 !important;
}
</style>